import React from 'react'
import styles from './Header.module.sass'
import { NavLink } from 'react-router-dom'
import logo from '../../assets/logo&title.svg'
import imageback from '../../assets/background2.svg'
import classNames from 'classnames'
import { useMediaQuery } from '@chakra-ui/react'
import { MenuIcon } from '../ui/Icon/menu'
import { useState } from 'react'
export const Header = () => {
    const [largerThan768px] = useMediaQuery('(min-width: 768px)')
    const [isShowMenu, SetIsShowMenu] = useState(false)
    console.log('hahahahah', isShowMenu)
    return (
        <header>
            {largerThan768px ? (
                <div className={styles.header}>
                    <div className={styles.imagebackground}>
                        <img src={imageback} alt="imageback" />
                    </div>

                    <NavLink to="/" style={{ zIndex: 0 }}>
                        <img className={styles.logo} src={logo} alt="logo" />
                    </NavLink>

                    <nav className={styles.navBar}>
                        <NavLink
                            className={({ isActive }) =>
                                classNames(
                                    styles.navBarItem,
                                    isActive && styles.navBarItemActive
                                )
                            }
                            to="/">
                            Home
                        </NavLink>
                        <NavLink
                            className={({ isActive }) =>
                                classNames(
                                    styles.navBarItem,
                                    isActive && styles.navBarItemActive
                                )
                            }
                            to="/blocks">
                            Blocks
                            {/* Blockchain */}
                        </NavLink>
                        <NavLink
                            className={({ isActive }) =>
                                classNames(
                                    styles.navBarItem,
                                    isActive && styles.navBarItemActive
                                )
                            }
                            to="/tokens">
                            Tokens
                        </NavLink>
                        <NavLink
                            className={({ isActive }) =>
                                classNames(
                                    styles.navBarItem,
                                    isActive && styles.navBarItemActive
                                )
                            }
                            to="/transactions">
                            Transactions
                            {/* NFTs */}
                        </NavLink>
                        {/* <NavLink
                        className={({ isActive }) =>
                            classNames(
                                styles.navBarItem,
                                isActive && styles.navBarItemActive
                            )
                        }
                        to="/resources">
                        Resources
                    </NavLink>
                    <NavLink
                        className={({ isActive }) =>
                            classNames(
                                styles.navBarItem,
                                isActive && styles.navBarItemActive
                            )
                        }
                        to="/developer">
                        Developer
                    </NavLink> */}
                        {/* <NavLink
                        className={({ isActive }) =>
                            classNames(
                                styles.navBarItem,
                                isActive && styles.navBarItemActive
                            )
                        }
                        to="/transactions">
                        Transactions
                    </NavLink>
                    <NavLink
                        className={({ isActive }) =>
                            classNames(
                                styles.navBarItem,
                                isActive && styles.navBarItemActive
                            )
                        }
                        to="/blocks">
                        Blocks
                    </NavLink>
                    <NavLink
                        className={({ isActive }) =>
                            classNames(
                                styles.navBarItem,
                                isActive && styles.navBarItemActive
                            )
                        }
                        to="/tokens">
                        Tokens
                    </NavLink> */}
                    </nav>
                </div>
            ) : (
                <>
                    <div className={styles.header}>
                        <div className={styles.imagebackground}>
                            <img src={imageback} alt="imageback" />
                        </div>
                        <div className={styles.logopng}>
                            <NavLink to="/" style={{ position: 'relative' }}>
                                <img
                                    className={styles.logo}
                                    src={logo}
                                    alt="logo"
                                />
                            </NavLink>
                        </div>
                        <MenuIcon
                            handler={(() => {
                                console.log('ok')
                                SetIsShowMenu(!isShowMenu)
                            }).bind(this)}
                            width={22}
                            height={22}
                            zIndex={0}></MenuIcon>
                    </div>
                    {isShowMenu && (
                        <dialog className={styles.dialog_overlay}>
                            <div className={styles.header}>
                                <div className={styles.imagebackground}>
                                    <img src={imageback} alt="imageback" />
                                </div>
                                <div className={styles.logopng}>
                                    <NavLink to="/" style={{ zIndex: 10 }}>
                                        <img
                                            className={styles.logo}
                                            src={logo}
                                            alt="logo"
                                        />
                                    </NavLink>
                                </div>
                                <MenuIcon
                                    handler={(() => {
                                        console.log('ok')
                                        SetIsShowMenu(!isShowMenu)
                                    }).bind(this)}
                                    width={22}
                                    height={22}
                                    isCross={true}></MenuIcon>
                            </div>
                            <nav className={styles.navBar}>
                                <NavLink
                                    className={({ isActive }) =>
                                        classNames(
                                            styles.navBarItem,
                                            isActive && styles.navBarItemActive
                                        )
                                    }
                                    to="/">
                                    Home
                                </NavLink>
                                <NavLink
                                    className={({ isActive }) =>
                                        classNames(
                                            styles.navBarItem,
                                            isActive && styles.navBarItemActive
                                        )
                                    }
                                    to="/blocks">
                                    Blocks
                                    {/* Blockchain */}
                                </NavLink>
                                <NavLink
                                    className={({ isActive }) =>
                                        classNames(
                                            styles.navBarItem,
                                            isActive && styles.navBarItemActive
                                        )
                                    }
                                    to="/tokens">
                                    Tokens
                                </NavLink>
                                <NavLink
                                    className={({ isActive }) =>
                                        classNames(
                                            styles.navBarItem,
                                            isActive && styles.navBarItemActive
                                        )
                                    }
                                    to="/transactions">
                                    Transactions
                                    {/* NFTs */}
                                </NavLink>
                            </nav>
                        </dialog>
                    )}
                </>
            )}
        </header>
    )
}
